import type { SocialPostSceneBlockV1 } from "@runcheetah/shared";

export const resolveSocialPostPreviewScale = (input: {
  frameWidth: number;
  frameHeight: number;
  maxWidth: number;
  maxHeight?: number;
}) => {
  const frameWidth = Math.max(1, Math.round(input.frameWidth));
  const frameHeight = Math.max(1, Math.round(input.frameHeight));
  const maxWidth = Math.max(1, Math.round(input.maxWidth));
  const scaleByWidth = Math.min(1, maxWidth / frameWidth);
  const scaleByHeight = input.maxHeight
    ? Math.min(1, Math.max(1, Math.round(input.maxHeight)) / frameHeight)
    : 1;
  const scale = Math.min(scaleByWidth, scaleByHeight);

  return {
    scale,
    width: Math.round(frameWidth * scale),
    height: Math.round(frameHeight * scale),
  };
};

export const getVisibleSortedSceneBlocks = (blocks: SocialPostSceneBlockV1[]) =>
  blocks.filter((block) => block.visible).toSorted((left, right) => left.zIndex - right.zIndex);
